<mat-sidenav-container>
  <mat-sidenav #sidenav mode="over">
    <teams-nav></teams-nav>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (appConfig.initialized) {
      <div class="overview-container">
        @if (pageLoaded) {
          @if (!loggedInSystemUserHasLatestEula) {
            <app-eula></app-eula>
          }
          @if (loggedInSystemUserHasLatestEula) {
            <div fxLayout="column" fxLayoutAlign=" stretch" fxLayoutGap="1em">
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <h1 id="welcome-message-header">{{ welcomeMessage }}</h1>
                <button
                  mat-stroked-button
                  color="primary"
                  class="customize-button"
                  (click)="toggleEditMode()"
                >
                  <mat-icon>{{ editMode ? 'check' : 'edit' }}</mat-icon>
                  {{ editMode ? 'Done' : 'Customize' }}
                </button>
              </div>
              @if (homePageWidgets.length > 0) {
                <div fxLayout="column" fxLayoutGap="1em">
                  <p class="widgets-update-time">
                    All data last updated
                    {{ widgetsUpdateDateTime | date: 'medium' }}
                  </p>
                  <div
                    fxLayout="row wrap"
                    fxLayout.lt-sm="column"
                    fxLayoutAlign="start none"
                    class="widget-container"
                    cdkDropList
                    cdkDropListOrientation="mixed"
                    [cdkDropListDisabled]="!editMode"
                    (cdkDropListDropped)="drop($event)"
                  >
                    @for (widget of visibleWidgets; track widget.id ?? $index) {
                      <div
                        class="widget-drag-item"
                        [class.edit-mode]="editMode"
                        fxFlex="32.75"
                        fxFlex.lt-lg="49"
                        cdkDrag
                        [cdkDragDisabled]="!editMode"
                      >
                        @if (editMode) {
                          <div class="widget-edit-bar">
                            <mat-icon class="drag-handle" cdkDragHandle
                              >drag_indicator</mat-icon
                            >
                            <button
                              mat-icon-button
                              class="remove-widget"
                              title="Remove widget"
                              (click)="removeWidget(widget)"
                            >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        }
                        <app-home-widget-card
                          [widget]="widget"
                          (addTeam)="openAddTeamDialog()"
                        ></app-home-widget-card>
                      </div>
                    }

                    @if (editMode) {
                      <button
                        type="button"
                        class="widget-block add-widget-tile"
                        fxFlex="32.75"
                        fxFlex.lt-lg="49"
                        (click)="openAddWidgetDialog()"
                      >
                        <mat-icon>add</mat-icon>
                        <span>Add widget</span>
                      </button>
                    }

                    <div fxFlex="32.75" fxFlex.lt-lg="49" class="widget-block">
                      <div>
                        <h2>Join Lineup's Community</h2>
                      </div>
                      <div
                        class="widget-contents"
                        fxLayout="column"
                        fxLayoutAlign="space-between stretch"
                      >
                        <p>
                          We are happy to bring you the Lineup Client Community
                          (LCC), a space for you and your fellow Lineup users to
                          connect.<br /><br />
                          Come on over and join the conversation with questions
                          like, "How are some of you capturing availability?" or
                          "Any suggestions for raising form response
                          metrics?"<br /><br />
                          Thank you and we look forward to seeing you in the
                          LCC!
                        </p>
                        <div fxFlex="nogrow" class="widget-buttons">
                          <a
                            mat-button
                            color="primary"
                            target="_blank"
                            href="https://support.lineupteams.com/hc/en-us/community/topics"
                            >Go to the community now</a
                          >
                        </div>
                      </div>
                    </div>

                    <div fxFlex="32.75" fxFlex.lt-lg="49" class="widget-block">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                        "
                      >
                        <h2>Recent Updates</h2>
                        @if (isStaff() && allowTenant) {
                          <button
                            class="add-entry"
                            mat-button
                            color="primary"
                            (click)="addEntry()"
                          >
                            <span class="team-button">Add Entry</span>
                          </button>
                        }
                      </div>
                      @for (release of releases; track release.link) {
                        <div
                          class="widget-contents"
                          fxLayout="column"
                          fxLayoutAlign="space-between stretch"
                        >
                          <div class="update-block" fxFlex="25">
                            <div fxlayout="row" fxLayoutAlign="start center">
                              @if (isStaff() && allowTenant) {
                                <button
                                  mat-icon-button
                                  color="primary"
                                  (click)="editEntry(release)"
                                >
                                  <mat-icon>edit</mat-icon>
                                </button>
                              }
                              <h4>
                                <a
                                  class="update-link"
                                  target="_blank"
                                  href="{{ release.link }}"
                                  >{{ release.title }}</a
                                >
                              </h4>
                            </div>
                            <div [class.ml-40]="isStaff() && allowTenant">
                              <p>{{ release.description }}</p>
                            </div>
                          </div>
                        </div>
                      }
                      <div fxFlex="nogrow" class="widget-buttons">
                        <a
                          mat-button
                          color="primary"
                          target="_blank"
                          href="https://support.lineupteams.com/hc/en-us/sections/360006008474-Release-Notes"
                          >View all release notes</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
